import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/pro-light-svg-icons'

import { useSetState } from '@campaignhub/react-hooks'

import Box from '../../Box'
import FormField from '../../FormField'
import Text from '../../Text'

const defaultState = {
  expanded: false,
}

const ExpandableSection = (props) => {
  const { children, defaultOpen, label, title, style } = props

  const [state, setState] = useSetState(defaultState)
  const { expanded } = state

  useEffect(() => setState({ expanded: defaultOpen }), [])

  return (
    <>
      <FormField
        direction="column"
        label={label}
        labelOnClick={() => setState({ expanded: !expanded })}
        labelRight={<FontAwesomeIcon icon={expanded ? faAngleUp : faAngleDown} />}
        labelStyle={{ cursor: 'pointer' }}
        style={style}
      >
        {!expanded && (
          <Box
            alignItems="center"
            borderColor="lineColor"
            fontSize="small"
            onClick={() => setState({ expanded: !expanded })}
            style={{ cursor: 'pointer' }}
          >
            <Text>{title}</Text>
          </Box>
        )}

        {expanded && children}
      </FormField>
    </>
  )
}

ExpandableSection.propTypes = {
  children: PropTypes.node,
  defaultOpen: PropTypes.bool,
  label: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

ExpandableSection.defaultProps = {
  defaultOpen: false,
}

export default ExpandableSection
